import axios from 'axios';
import { API_BASE_URL } from '@/lib/apiBase';

export default axios.create({
  baseURL: `${API_BASE_URL}/marketplace/customer`,
  withCredentials: true,
});
